import React from 'react';
import RegisterButton from './RegisterButton';
import AnchorButton from './AnchorButton';
import IdentifyButton from './IdentifyButton';
import DownloadButton from './DownloadButton';
import BtnPlay from '../../btnPlay/BtnPlay';
import LinkButton from './LinkButton';
import BtnRegulations from './BtnRegulations';
import LockedButton from './LockedButton';
import FinalDayButton from './FinalDayButton';
import FinalistsListButton from './FinalistsListButton';
import RegisterForFinalButton from './RegisterForFinal';

const BtnComponent = ({ type, bgcolor, text, icon, className, anchorId, link, ...otherProps }) => {

  switch (type) {
    case 'register':
      return <RegisterButton bgcolor={bgcolor} text={text} icon={icon} className={className} {...otherProps} />;
    case 'play':
      return <BtnPlay text={text} className={className} />;
    case 'anchor':
      return <AnchorButton anchorId={anchorId} bgcolor={bgcolor} text={text} icon={icon} className={className} {...otherProps} />;
    case 'identify':
      return <IdentifyButton bgcolor={bgcolor} text={text} icon={icon} className={className} {...otherProps} />;
    case 'download':
      return <DownloadButton text={text} className={className} {...otherProps} />;
    case 'link':
      return <LinkButton text={text} className={className} href={link} {...otherProps} />;
    case 'regulations':
      return <BtnRegulations text={text} icon={icon} className={className} {...otherProps} />;
    case 'registerForFinal':
      return <RegisterForFinalButton text={text} className={className} {...otherProps} />;
    case 'finalLocked':
      return <LockedButton text={text} className={className} {...otherProps} />;
    case 'finalDayStudent':
      return <FinalDayButton text={text} className={className} {...otherProps} />;
    case 'finalistsList':
      return <FinalistsListButton text={text} className={className} {...otherProps} />;
    default:
      return null;
  }
};

export default BtnComponent;

